import classes from "./Layout.module.css";
import Header from "../Header/Header";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Trading from "../Trading/Trading";
import Tabs from "../Tabs/Tabs";
import PayoutPool from "../PayoutPool/PayoutPool";
import Profile from "../Profile/Profile";
import Refer from "../Refer/Refer";
import { env } from "../../constants/env";
import PaymentCompleted from "../PurchaseOptions/PaymentCompleted";
import PaymentCancelled from "../PurchaseOptions/PaymentCancelled";
import DataEngine from "../DataEngine/DataEngine";
import { useState } from "react";
import LeaderboardContent from "../LeaderboardContent/LeaderboardContent";
import FlywheelStats from "../FlywheelStats/FlywheelStats";
import Arena from "../Arena/Arena";

const Layout = () => {
  const location = useLocation();
  const [showPurchase, setShowPurchase] = useState(false);
  return (
    <div className={classes.wrapper}>
      <Header />
      
        <div className={``}>
        {location.pathname !== "/refer" && <>
          {/* <h1>Beta Portal</h1> */}
          {/* {!showPurchase && <Tabs />} */}
          </>}
          <div className={`${classes.content}`}>
            <Routes>
              <Route path="/" element={<Navigate to="/trading" />} />
              <Route path="/trading" element={<Trading showPurchase={showPurchase} setShowPurchase={(value) => setShowPurchase(value)} />} />
              <Route path="/data-engine" element={<DataEngine />} />
              <Route path="/leaderboard" element={<LeaderboardContent />} />
              <Route path="/profile" element={<Profile showPurchase={showPurchase} setShowPurchase={(value) => setShowPurchase(value)}/>} />
              <Route path="/refer" element={<Refer />} />
              <Route path="/payment-complete" element={<PaymentCompleted />} />
              <Route path="purchase-cancel" element={<PaymentCancelled />} />
              <Route path="stats" element={<FlywheelStats />} />
              {/* <Route path="/arena" element={<Arena />} /> */}
            </Routes>
          </div>
        </div>
     
       {!showPurchase && <div className={`${classes.footer} d-flex justify-content-end`}> <a href={`${env.siteUrl}/terms`} target="_blank"><button>Terms of service</button></a></div>}
    </div>
  );
};

export default Layout;
